/* BrickHead Funnel JS. Ein delegierter Listener am document (Drawer-HTML wird ersetzt). */
(function () {
  if (window.__bhInit) return; window.__bhInit = true;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var SEC = 'bh-cart-drawer';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var store = {
    get: function (k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} },
    sget: function (k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } },
    sset: function (k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) {} }
  };
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  /* Countdown: je Besucher X Stunden, danach neu */
  function initCountdown() {
    $$('[data-bh-countdown]').forEach(function (el) {
      var hrs = parseInt(el.getAttribute('data-hours'), 10) || 2;
      var end = parseInt(store.get('bh_cd_end'), 10);
      var now = Date.now();
      if (!end || end <= now) { end = now + hrs * 3600000; store.set('bh_cd_end', String(end)); }
      var d = $('[data-d]', el), h = $('[data-h]', el), m = $('[data-m]', el), s = $('[data-s]', el);
      function tick() {
        var left = end - Date.now();
        if (left <= 0) { end = Date.now() + hrs * 3600000; store.set('bh_cd_end', String(end)); left = end - Date.now(); }
        var t = Math.floor(left / 1000);
        d.textContent = pad(Math.floor(t / 86400)); h.textContent = pad(Math.floor(t % 86400 / 3600));
        m.textContent = pad(Math.floor(t % 3600 / 60)); s.textContent = pad(t % 60);
      }
      tick(); setInterval(tick, 1000);
    });
  }

  /* Slider (Galerie, Bewertungen, Bild-Slider) */
  function initSliders() {
    $$('[data-bh-gallery],[data-bh-slider]').forEach(function (box) {
      var track = $('[data-bh-track]', box); if (!track) return;
      var goto = $$('[data-bh-goto]', box);
      function step() { var c = track.children[0]; return c ? c.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0) : track.clientWidth; }
      function idx() { return Math.round(track.scrollLeft / Math.max(1, step())); }
      function mark() {
        var i = idx();
        goto.forEach(function (b) { b.classList.toggle('is-active', +b.getAttribute('data-bh-goto') === i); });
        var strip = $('[data-bh-thumbs]', box), act = strip && $('.is-active', strip);
        if (act && strip.scrollWidth > strip.clientWidth) strip.scrollTo({ left: act.offsetLeft - strip.offsetLeft - (strip.clientWidth - act.offsetWidth) / 2, behavior: 'smooth' });
      }
      var raf; track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(mark); }, { passive: true });
      box.__bhGo = function (i) {
        var max = track.children.length - 1; if (i < 0) i = max; if (i > max) i = 0;
        track.scrollTo({ left: i * step(), behavior: 'smooth' });
      };
      box.__bhIdx = idx;
    });
  }

  /* Kaufblock */
  function tierOf(el) { return el.closest('[data-bh-tier]'); }
  function selectTier(prod, tier) {
    $$('[data-bh-tier]', prod).forEach(function (t) {
      var on = t === tier; t.classList.toggle('is-selected', on);
      var r = $('input[type=radio]', t); if (r) r.checked = on;
    });
    var addons = $('[data-bh-addons]', prod), slot = $('[data-bh-addon-slot]', tier);
    if (addons && slot && addons.parentNode !== slot) slot.appendChild(addons);
    updateSticky(prod);
  }
  function updateSticky(prod) {
    var t = $('[data-bh-tier].is-selected', prod), sp = $('[data-bh-sticky-price]', prod);
    if (!t || !sp) return;
    sp.innerHTML = t.getAttribute('data-sticky') || '';
  }
  function initProducts() {
    $$('[data-bh-product]').forEach(function (prod) {
      var sel = $('[data-bh-tier].is-selected', prod); if (sel) selectTier(prod, sel);
      var btn = $('[data-bh-atc]', prod), sticky = $('[data-bh-sticky]', prod);
      if (btn && sticky && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          var e = en[0];
          var show = !e.isIntersecting && window.scrollY > 300;
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
          var b = $('[data-bh-sticky-btn]', sticky); if (b) b.tabIndex = show ? 0 : -1;
        }, { threshold: 0 }).observe(btn);
      }
    });
  }
  function collectItems(prod) {
    var t = $('[data-bh-tier].is-selected', prod); if (!t) return [];
    var counts = {}, order = [];
    $$('[data-bh-variant]', t).forEach(function (s) {
      var id = s.value; if (!id) return;
      if (!counts[id]) { counts[id] = 0; order.push(id); } counts[id]++;
    });
    var qty = +t.getAttribute('data-qty') || 1;
    if (order.length === 1 && $$('select[data-bh-variant]', t).length === 0) counts[order[0]] = qty;
    return order.map(function (id) { return { id: id, quantity: counts[id] }; });
  }
  function addFormData(items) {
    var fd = new FormData();
    items.forEach(function (it, k) { fd.append('items[' + k + '][id]', it.id); fd.append('items[' + k + '][quantity]', it.quantity); });
    fd.append('sections', SEC); fd.append('sections_url', window.location.pathname);
    return fetch(ROOT + 'cart/add.js', { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  /* Add-ons ueber update.js (setzt Menge 1, nie doppelt). Gemessen 11.10.2026: Shopify meldet product_added_to_cart fuer add.js (Formular UND JSON) und update.js je neuer Zeile */
  function addJson(items) {
    var up = {}; items.forEach(function (it) { up[it.id] = it.quantity; });
    return fetch(ROOT + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ updates: up, sections: SEC, sections_url: window.location.pathname }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function atc(prod, btn) {
    var items = collectItems(prod), err = $('[data-bh-err]', prod);
    if (!items.length) return;
    var addons = $$('[data-bh-addon]:checked', prod).map(function (c) { return { id: c.value, quantity: 1 }; });
    btn.disabled = true; if (err) err.textContent = '';
    /* Masken als Formulardaten (Shopify erkennt nur so product_added_to_cart / Meta AddToCart), Add-ons danach als JSON */
    addFormData(items).then(function (res) {
      if (!addons.length) return res;
      return addJson(addons).catch(function () { return res; });
    }).then(function (res) {
      renderDrawer(res && res.sections && res.sections[SEC]);
      $$('[data-bh-addon]:checked', prod).forEach(function (c) { c.checked = false; });
      openDrawer();
    }).catch(function (e) {
      var msg = e && typeof e.description === 'string' ? e.description : '';
      if (err) err.textContent = msg || 'Das hat nicht geklappt. Bitte versuch es noch einmal.';
    }).then(function () { btn.disabled = false; });
  }

  /* Drawer */
  function drawer() { return $('[data-bh-drawer]'); }
  function renderDrawer(html) {
    var d = drawer(); if (!d) return;
    if (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = $('[data-bh-drawer-content]', doc), cur = $('[data-bh-drawer-content]', d);
      if (fresh && cur) cur.replaceWith(fresh);
    }
    var c = $('[data-bh-drawer-content]', d), n = c ? +c.getAttribute('data-count') : 0;
    $$('[data-bh-count]').forEach(function (b) { b.textContent = n; b.hidden = !n; });
    tickTimer();
  }
  function refreshDrawer() {
    return fetch(ROOT + '?sections=' + SEC, { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (j) { renderDrawer(j[SEC]); });
  }
  function openDrawer() {
    var d = drawer(); if (!d) return false;
    if (!store.sget('bh_cart_until') || +store.sget('bh_cart_until') < Date.now()) store.sset('bh_cart_until', String(Date.now() + (+d.getAttribute('data-minutes') || 10) * 60000));
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); document.body.classList.add('bh-lock');
    tickTimer();
    var x = $('[data-bh-drawer-close].bh-iconbtn', d); if (x) setTimeout(function () { x.focus({ preventScroll: true }); }, 50);
    return true;
  }
  function closeDrawer() {
    var d = drawer(); if (!d) return;
    d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); document.body.classList.remove('bh-lock');
  }
  function tickTimer() {
    var el = $('[data-bh-timer]'); if (!el) return;
    var until = +store.sget('bh_cart_until');
    var d = drawer();
    if (!until || until < Date.now()) { until = Date.now() + ((d && +d.getAttribute('data-minutes')) || 10) * 60000; store.sset('bh_cart_until', String(until)); }
    var t = Math.max(0, Math.floor((until - Date.now()) / 1000));
    el.textContent = pad(Math.floor(t / 60)) + ':' + pad(t % 60);
  }
  function changeLine(line, qty) {
    var d = drawer(); if (d) d.classList.add('is-busy');
    return fetch(ROOT + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ line: line, quantity: qty, sections: SEC, sections_url: window.location.pathname }) })
      .then(function (r) { return r.json(); })
      .then(function (j) { renderDrawer(j.sections && j.sections[SEC]); })
      .catch(refreshDrawer)
      .then(function () { if (d) d.classList.remove('is-busy'); });
  }

  /* Ein Listener fuer alles */
  document.addEventListener('click', function (e) {
    var t = e.target, el;
    if ((el = t.closest('[data-bh-cart-open]')) && drawer()) { e.preventDefault(); refreshDrawer(); openDrawer(); return; }
    if ((el = t.closest('[data-bh-drawer-close]'))) { if (el.tagName === 'A' && el.getAttribute('href') !== '#') { /* Weiter einkaufen */ if (location.pathname === '/' || el.getAttribute('href') === location.pathname) e.preventDefault(); } closeDrawer(); return; }
    if ((el = t.closest('[data-bh-line]'))) { e.preventDefault(); changeLine(+el.getAttribute('data-bh-line'), +el.getAttribute('data-qty')); return; }
    if ((el = t.closest('[data-bh-menu-open]'))) { var m = $('[data-bh-menu]'); if (m) { m.classList.add('is-open'); m.setAttribute('aria-hidden', 'false'); } return; }
    if ((el = t.closest('[data-bh-menu-close]'))) { var m2 = $('[data-bh-menu]'); if (m2) { m2.classList.remove('is-open'); m2.setAttribute('aria-hidden', 'true'); } return; }
    if ((el = t.closest('[data-bh-search-toggle]'))) { var s = $('[data-bh-search]'); if (s) { s.classList.toggle('is-open'); var i = $('input[type=search]', s); if (i && s.classList.contains('is-open')) i.focus(); } return; }
    if ((el = t.closest('[data-bh-goto]'))) { var box = el.closest('[data-bh-gallery],[data-bh-slider]'); if (box && box.__bhGo) box.__bhGo(+el.getAttribute('data-bh-goto')); return; }
    if ((el = t.closest('[data-bh-prev],[data-bh-next]'))) { var b2 = el.closest('[data-bh-gallery],[data-bh-slider]'); if (b2 && b2.__bhGo) b2.__bhGo(b2.__bhIdx() + (el.hasAttribute('data-bh-next') ? 1 : -1)); return; }
    if ((el = t.closest('[data-bh-atc]'))) { var p = el.closest('[data-bh-product]'); if (p && !el.disabled) atc(p, el); return; }
    if ((el = t.closest('[data-bh-sticky-btn]'))) { var p2 = el.closest('[data-bh-product]'), tiers = p2 && $('[data-bh-tiers]', p2); if (tiers) { var y = tiers.getBoundingClientRect().top + window.scrollY - 70; window.scrollTo({ top: y, behavior: 'smooth' }); } return; }
    if ((el = t.closest('[data-bh-tier]')) && !t.closest('.bh-tier__body')) { var pr = el.closest('[data-bh-product]'); if (pr && !el.classList.contains('is-selected')) selectTier(pr, el); }
  });
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('select[data-bh-variant]')) {
      var o = t.options[t.selectedIndex], img = t.closest('.bh-opt') && $('[data-bh-thumb]', t.closest('.bh-opt'));
      if (img && o && o.getAttribute('data-img')) img.src = o.getAttribute('data-img');
      /* Erst bei einer Gesicht-Auswahl zum Variantenbild springen; beim Laden bleibt das Hauptbild vorne (kein change beim Init) */
      var pr0 = t.closest('[data-bh-product]'), gal = pr0 && $('[data-bh-gallery]', pr0);
      if (gal && gal.__bhGo && o && o.hasAttribute('data-media')) gal.__bhGo(+o.getAttribute('data-media'));
    } else if (t.matches('.bh-tier__input')) {
      var tier = tierOf(t), pr = t.closest('[data-bh-product]'); if (tier && pr) selectTier(pr, tier);
    } else if (t.matches('[data-bh-drawer-addon]') && t.checked) {
      var d = drawer(); if (d) d.classList.add('is-busy');
      addJson([{ id: t.value, quantity: 1 }]).then(function (j) { renderDrawer(j.sections && j.sections[SEC]); }).catch(refreshDrawer).then(function () { if (d) d.classList.remove('is-busy'); });
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawer(); var m = $('[data-bh-menu]'); if (m) { m.classList.remove('is-open'); m.setAttribute('aria-hidden', 'true'); } }
  });
  setInterval(tickTimer, 1000);

  function init() { initCountdown(); initSliders(); initProducts(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { initSliders(); initProducts(); });
})();
